(function(){
    'use strict';

    angular
    .module('appback')
    .controller('NovarumController', NovarumController)
 
    NovarumController.$inject = ["NovarumService","$http","$timeout", "$log", "$document","$sce"];
              
    function NovarumController(NovarumService,$http,$timeout, $log, $document,$sce)
    {                         
        var vm = this;
        vm.novarum = {};
       	vm.cambiarInter = function(id){
       		console.log("chanbge",vm.novarum);
       		if(angular.isDefined(vm.novarum[id])){

       			NovarumService.guardarinterp(id,vm.novarum[id],function(data){
        			//location.reload();
        		});
        		
       			console.log("novarum",vm.novarum[id]);
       		}
       	}

        vm.downloadPDF = function(historicosm_id){
            console.log("DOWNLOAD PDF", historicosm_id);
            NovarumService.downloadPDF(historicosm_id,function(data){
                if(data != ''){
                    window.open('/backend/historicosm/downloadpdf/'+historicosm_id)
                }
                return data;
            });
        }
    }
  
})();